var WDN = WDN || {};

/* Product gallery scroll */
(function () {
  var init, onScroll;
  var freeze;

  // Config
  var config = {
    debounceBy: 20,
    maxscreenWidth: 830,
    offset: 2,
  };

  //  Depends on
  var Debounce = WDN.Debounce;

  var gallery = document.querySelector("[data-product-gallery]");

  // state
  var isFrozen = false;

  freeze = function () {
    if (isFrozen) return;
    gallery.style = "overflow:hidden";

    isFrozen = true;
    setTimeout(function () {
      gallery.style = "overflow-y:scroll";
      isFrozen = false;
    }, 500);
  };

  onScroll = function () {
    var reachedTop = gallery.scrollTop === 0;
    var reachedBottom = gallery.scrollTop + gallery.clientHeight + config.offset >= gallery.scrollHeight;

    if (reachedTop || reachedBottom) {
      freeze();
    }
  };

  init = function () {
    if (!gallery) return;
    if (window.innerWidth > config.maxscreenWidth) return;
    var onScrollDebounced = Debounce(onScroll, config.debounceBy);
    gallery.addEventListener("scroll", onScrollDebounced);
  };

  //  init();
})();

/* ASYNC MODALS */
(function () {
  // Details
  new WDN.SectionRenderer({
    selectors: {
      trigger: "wdn-drawer-open[data-id='product_details']",
      output: "[data-product-details-content]",
    },
    useCurrentPath: true,
    sections: ["async-product-details"],
    events: ["click", "mouseover"],
  });

  // Size guide
  new WDN.SectionRenderer({
    selectors: {
      trigger: "wdn-drawer-open[data-id='product_sizeguide']",
      output: "[data-product-sizeguide-content]",
    },
    useCurrentPath: true,
    sections: ["async-product-sizeguide"],
    events: ["click", "mouseover"],
  });

  // Delivery
  new WDN.SectionRenderer({
    selectors: {
      trigger: "wdn-drawer-open[data-id='delivery']",
      output: "[data-delivery-content]",
    },
    sections: ["async-delivery-info"],
    events: ["click", "mouseover"],
  });

  // Returns
  new WDN.SectionRenderer({
    selectors: {
      trigger: "wdn-drawer-open[data-id='returns']",
      output: "[data-returns-content]",
    },
    sections: ["async-returns-info"],
    events: ["click", "mouseover"],
  });
})();

/* Product variations */
(function () {
  var init, fetchVariations;
  var handleFetchSuccess, handleFetchError, getCurrentProductTitle;

  var nodes = {
    container: document.querySelector("[data-product-variations]"),
  };

  getCurrentProductTitle = function () {
    return nodes.container.getAttribute("data-product-variations");
  };

  handleFetchSuccess = function (res) {
    var parser = new DOMParser();
    var parsedResponse = parser.parseFromString(res, "text/html");

    var currentProductInVariations = parsedResponse.querySelector("[data-product-variation='" + getCurrentProductTitle() + "']");

    // Check if current product is among variations
    if (currentProductInVariations) {
      // If so - remove it
      currentProductInVariations.remove();
    }

    var variationList = parsedResponse.querySelectorAll("[data-product-variation]");

    // If no recommendations found stop the function
    if (variationList.length === 0) return;

    // Check if we have more than 4 recommendations - remove extra
    if (variationList.length > 4) {
      variationList.forEach(function (variation, i) {
        if (i < 4) return;
        variation.remove();
      });
    }

    // Render
    nodes.container.innerHTML = parsedResponse.querySelector("body").innerHTML;
  };

  handleFetchError = function () {};

  fetchVariations = function () {
    var query = getCurrentProductTitle().split(" - ")[0];

    WDN.Request.Get({
      url: Shopify.routes.root + "search?q=" + query + "&view=variations&type=product",
      onSuccess: handleFetchSuccess,
      onError: handleFetchError,
    });
  };

  init = function () {
    if (!nodes.container) return;
    fetchVariations();
  };

  init();
})();
